// extracted by mini-css-extract-plugin
export default {"card":"l2-z"};